/**
 * Gamification Service — API calls for stars, streak, badges, challenges, recaps
 */
class GamificationService {
  static instance = null;
  api = null;

  static getInstance() {
    if (!GamificationService.instance) {
      GamificationService.instance = new GamificationService();
    }
    return GamificationService.instance;
  }

  setApi(api) {
    this.api = api;
  }

  async getSummary() {
    try {
      const res = await this.api.get('/gamification/summary');
      return res.data;
    } catch (e) {
      console.error('Erreur gamification summary:', e);
      return { stars: 0, streak: 0, active_today: false, first_child_name: '', has_asked_first_question: false };
    }
  }

  async getStars() {
    try {
      const res = await this.api.get('/gamification/stars');
      return res.data;
    } catch (e) {
      console.error('Erreur gamification stars:', e);
      return null;
    }
  }

  async convertStars(rewardType) {
    const res = await this.api.post('/gamification/stars/convert', { reward_type: rewardType });
    return res.data;
  }

  async getStreak() {
    try {
      const res = await this.api.get('/gamification/streak');
      return res.data;
    } catch (e) {
      console.error('Erreur gamification streak:', e);
      return null;
    }
  }

  async getBadges(childId) {
    try {
      const res = await this.api.get(`/gamification/badges/${childId}`);
      return res.data;
    } catch (e) {
      console.error('Erreur gamification badges:', e);
      return { badges: [], child_name: '' };
    }
  }

  async getChallenge() {
    try {
      const res = await this.api.get('/gamification/challenge');
      return res.data;
    } catch (e) {
      console.error('Erreur gamification challenge:', e);
      return { challenge: null };
    }
  }

  async getWeeklyRecap() {
    try {
      const res = await this.api.get('/gamification/weekly-recap');
      return res.data;
    } catch (e) {
      console.error('Erreur gamification recap:', e);
      return { recap: null };
    }
  }

  async dismissWeeklyRecap() {
    await this.api.post('/gamification/weekly-recap/dismiss');
  }

  async harvestStars(childId, conversationId, allCorrect = false) {
    const res = await this.api.post('/gamification/harvest-stars', {
      child_id: childId,
      conversation_id: conversationId,
      all_correct: allCorrect,
    });
    return res.data;
  }
}

export default GamificationService;
